'use strict';

var getLowerUnitIndex = require('./getLowerUnitIndex'),
    setUnitAndLowerToEdge = require('./setUnitAndLowerToEdge');

function resetLowerUnits(d, unitIndex) {
  return setUnitAndLowerToEdge(d, getLowerUnitIndex(unitIndex));
}

module.exports = resetLowerUnits;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/internal/resetLowerUnits.js
// module id = 222
// module chunks = 1